import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { apiFetch } from "../config";

function ScanForm() {
  const { id } = useParams();
  const [cours, setCours] = useState(null);
  const [message, setMessage] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    apiFetch(`/cours/${id}`)
      .then((r) => r.json())
      .then(setCours)
      .catch(() => setCours(null));

    apiFetch(`/presence/${id}`, { method: "POST" })
      .then(async (res) => {
        const data = await res.json();
        setMessage(data.message || "Erreur.");
        setDone(res.ok);
      })
      .catch(() => setMessage("Erreur de connexion au serveur."));
  }, [id]);

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={styles.title}>Émargement</h2>

        {cours ? (
          <div style={styles.courseInfo}>
            <p style={styles.courseTitle}>{cours.intitule}</p>
            <p style={styles.courseMeta}>
              {new Date(cours.date).toLocaleDateString("fr-FR")} &bull;{" "}
              {cours.heure_debut?.slice(0, 5)} – {cours.heure_fin?.slice(0, 5)}
            </p>
            <p style={styles.courseMeta}>{cours.professeur}</p>
          </div>
        ) : (
          <p style={styles.courseMeta}>Chargement du cours...</p>
        )}

        {done ? (
          <p style={styles.success}>{message}</p>
        ) : message ? (
          <p style={styles.error}>{message}</p>
        ) : (
          <p style={styles.courseMeta}>Enregistrement de ta présence...</p>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f0f4f8",
    padding: "20px",
  },
  card: {
    background: "#fff",
    borderRadius: "12px",
    padding: "32px 28px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    width: "100%",
    maxWidth: "400px",
  },
  title: {
    textAlign: "center",
    marginBottom: "20px",
    fontSize: "22px",
    color: "#1a1a2e",
  },
  courseInfo: {
    background: "#f7f9fc",
    borderRadius: "8px",
    padding: "12px 16px",
    marginBottom: "24px",
  },
  courseTitle: {
    fontWeight: "bold",
    fontSize: "16px",
    margin: "0 0 4px 0",
    color: "#1a1a2e",
  },
  courseMeta: {
    fontSize: "13px",
    color: "#666",
    margin: "2px 0",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  input: {
    padding: "12px 14px",
    borderRadius: "8px",
    border: "1px solid #ddd",
    fontSize: "16px",
    outline: "none",
  },
  button: {
    padding: "14px",
    background: "#4f46e5",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    cursor: "pointer",
    marginTop: "4px",
  },
  success: {
    textAlign: "center",
    color: "#16a34a",
    fontWeight: "bold",
    fontSize: "18px",
    marginTop: "12px",
  },
  error: {
    textAlign: "center",
    color: "#dc2626",
    fontSize: "14px",
    marginTop: "8px",
  },
};

export default ScanForm;
